module.exports = __webpack_public_path__ + "static/media/brawl_stars_tara.eb6a7a91.png";